module.exports = __webpack_public_path__ + "static/media/utkast_affisch.a50f4023.png";